import CleaningIcon from '../Images/cleaning-icon.svg'


const pressureWashing = [


    {
        id: 38, 
        image: CleaningIcon,
        option: 'Up to 50 Square Meter',
        desc: 'For all exterior areas'  
    },{
        id: 39, 
        image: CleaningIcon,
        option: '50 to 100 Square Meter',
        desc: 'For all exterior areas'  
    },{
        id: 40, 
        image: CleaningIcon,
        option: '100 to 150 Square Meter',
        desc: 'For all exterior areas'  
    },{
        id: 41, 
        image: CleaningIcon,
        option: '150 Square Meter and more',
        desc: 'For all exterior areas'  
    },

]

export default pressureWashing;

  
